<template>
  <FormLabel :ok="ok" :increased="increased" :text="text" :error="error" :class="{'disabled':disabled, 'filled' : value}">
    <input class="formfield" :placeholder="placeholder" autocomplete="off"
           type="text"
           :disabled="disabled"
           inputmode="numeric"
           v-maska="'##.##.####'"
           maxlength="10"
           :name="name"
           @blur="filledCheck"
           v-model="val">
  </FormLabel> 
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import FormField from '@/mixins/FormField.vue'
import { maska } from 'maska'

export default {
  components: { FormLabel },
  mixins: [FormField],
  directives: { maska },
  props: {
    required: { type: Boolean, default: false },
    increased: { type: Boolean, default: false },
    name: {type: String, required: true},
    value: {type: String, default: ''},
    text: {type: String, required: true},
    placeholder: {type: String},
    validation: {type: Function, default: ()=>''},
    filled: {type: Function, default: (v)=>v.length==10?true:false},
    errorcont: { type: Object },
    disabled: { type: Boolean, default: false },
  },
  data: ()=>({
    error: '',
  }),
  methods:{
    isValidDate(string){
      if (string[0] > 3 || (string[0] == 3 && string[1] > 1))
        return 'Некорректная дата'
      if (string[3] > 1 || (string[3] == 1 && string[4] > 2))
        return 'Некорректная дата'
      if (string && string.length == 10) {
        let split = string.split('.')
        let dd = parseInt(split[0])
        let mm = parseInt(split[1]) - 1
        let yyyy = parseInt(split[2])
        if ([dd,mm,yyyy].find(el=>isNaN(el)) !== undefined || dd < 1 || yyyy < 1 || mm < 0) 
          return 'Некорректная дата' 
        let date = new Date(yyyy, mm, dd)
        if (date.getDate() !== dd || date.getMonth() !== mm || date.getFullYear() !== yyyy)
          return 'Некорректная дата'
        if (date > new Date())
          return 'Указана дата из будущего'
      }
      return ''
    },
    filledCheck(){
      if (!this.filled(this.value) && this.required) 
        this.error = "Заполните поле"
    }
  },
  computed:{
    ok(){
      if (!this.value || !this.filled(this.value) || this.error) return false
      return true
    },    
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
  },
  watch: {
    error(val) {
      if (this.errorcont)
        this.$set(this.errorcont, this.name, val)
    },
    value(val, old){
      if (val != old)
        this.$emit('input', val)
      this.error = ''
      this.error = this.isValidDate(val)
      if (!this.error && val) 
        this.error = this.validation(val)
      if (!this.error && this.required) this.filledCheck()      
    }
  }
}
</script>

<style lang="sass">

</style>